import { yup } from '@framework/validation/initYup.ts';
import { fromPairs } from 'lodash';

export enum FormBuilderMetaFlags {
  /**
   * Flag meta per richiedere al FormBuilder di saltare l'impostazione
   * del valore di default dello schema.
   */
  SkipDefaultValue = 'formBuilder@skipDefaultValue',
  /**
   * Flag meta per richiede al FormBuilder di saltare l'applicazione
   * delle regole. È utilizzato quando lo schema ritornato dal Widget non
   * è uno schema "standard", oppure ve ne sono di addizionali
   */
  SkipValidationRules = 'formBuilder@SkipValidationRules',
  /**
   * Flag meta per richiedere alle direttive di non esportare metadati per
   * questo schema, senza saltare le regole di validazione.
   */
  SkipExportMetadata = 'formBuilder@SkipExportMetadata',
  /**
   * Serializza le opzioni di un widget in un oggetto
   */
  SerializeSiblingOptions = 'formBuilder@SerializeSiblingOptions',
  /**
   * In caso di serializzazione delle opzioni di un widget in un oggetto, indica
   * il campo da cui prendere le chiavi. Nel caso di opzioni semplici (stringhe),
   * la chiave è l'opzione stessa.
   * Supportiamo massimo un livello di profondità (es. oggetti con chiave "id" o "value").
   */
  SerializeSiblingOptionsKeyField = 'formBuilder@SerializeSiblingOptionsKeyField',
  /**
   * Ignora la regola "Required" per il widget
   */
  IgnoreRequired = 'formBuilder@IgnoreRequired',
  /**
   * Flag meta per richiedere al FormBuilder di saltare la configurazione
   * della label dello schema.
   */
  SkipLabel = 'formBuilder@SkipLabel',
  /**
   * Flag meta per richiedere al FormBuilder di saltare l'applicazione
   * della condizione di abilitazione (setEnabledCondition).
   * Utilizzato per schema derivati (es. list schema del MultiSelect)
   * il cui valore è calcolato da un altro schema.
   */
  SkipEnabledCondition = 'formBuilder@skipEnabledCondition',
}

declare module 'yup' {
  interface Schema {
    formBuilderFlags(
      // Permette di aggiungere flag meta personalizzati
      ...flag: Array<FormBuilderMetaFlags | `formBuilder@${string}`>
    ): this;
  }
}

yup.addMethod(
  yup.Schema as any,
  'formBuilderFlags',
  function (...flags: FormBuilderMetaFlags[]) {
    return this.meta(fromPairs(flags.map(flag => [flag, true])));
  },
);
